<template>
    <div class="text-center p-6"
        :class="classes">
        <div class="mb-8">
            © 2018 {{ $env.VUE_APP_NAME }}. All rights reserved. <router-link :to="{ name: 'terms' }" class="text-blue no-underline"><strong>Terms of Service</strong></router-link>
        </div>
        <div class="text-center">
            <a href="https://twitter.com/laragleofficial" target="_blank" class="hover:text-blue mr-6 no-underline text-grey-dark"><twitter-icon /></a>
                    <a href="https://www.facebook.com/laragle" target="_blank" class="hover:text-blue mr-6 no-underline text-grey-dark"><facebook-icon /></a>
        </div>
    </div>
</template>
<script>
    import {
        mapGetters
    } from 'vuex';
    export default {
        computed: {
            ...mapGetters({
                user: 'auth/user'
            }),
            classes() {
                if (!this.user) {
                    //return 'bg-blue text-white';
                }
                //return 'bg-grey-lighter'
            }
        }
    }
</script>